import styled from '@emotion/styled';

import Icon from '@/assets/icons/icon_dokanto_arrow.svg';
import { mq } from '@/utility/mediaQuery';

export const SetNumWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
  }),
);

export const ArrowIcon = styled.i(() =>
  mq({
    width: ['9px', '12px', '12px', '12px'],
    backgroundImage: `url(${Icon})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    margin: '0 2px',
  }),
);
